import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSingleUser = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M7.39047 27.2768C7.39281 27.278 7.39398 27.278 7.39633 27.2791C13.0893 29.4847 18.7838 29.4987 24.4748 27.2733C24.4771 27.2733 24.4783 27.2721 24.4806 27.271C25.664 26.8005 26.3811 25.6034 26.2229 24.3527C26.2229 24.3504 26.2217 24.3469 26.2217 24.3446C25.5058 19.0275 21.1553 14.961 15.9332 14.961C10.7147 14.961 6.36547 19.0251 5.6378 24.3374C5.6378 24.3409 5.63663 24.3444 5.63663 24.3479C5.47962 25.6032 6.19903 26.8062 7.39063 27.2755L7.39047 27.2768ZM8.09112 25.5464C7.69861 25.3903 7.46075 24.9955 7.51231 24.581C8.11337 20.2143 11.6435 16.8253 15.9342 16.8253C20.2271 16.8253 23.7575 20.2151 24.3493 24.5855C24.3997 24.9954 24.1642 25.3878 23.7763 25.5427C18.5494 27.584 13.3204 27.5712 8.09235 25.545L8.09112 25.5464ZM15.9342 0.988281C12.3138 0.988281 9.37279 3.91117 9.37279 7.50946C9.37279 11.1077 12.3137 14.0306 15.9342 14.0306C19.5545 14.0306 22.4955 11.1077 22.4955 7.50946C22.4955 3.91117 19.5546 0.988281 15.9342 0.988281ZM15.9342 2.85147C18.5212 2.85147 20.6208 4.93825 20.6208 7.50946C20.6208 10.0807 18.5212 12.1674 15.9342 12.1674C13.3471 12.1674 11.2475 10.0807 11.2475 7.50946C11.2475 4.93825 13.3471 2.85147 15.9342 2.85147Z",
		fill: "black"
	})]
});
const ForwardRef = forwardRef(SvgSingleUser);
export { ForwardRef as ReactComponent };
